import { Component, Input, ElementRef, QueryList, ViewChildren, ViewChild, HostListener } from '@angular/core';
import { GlobalConstants } from '../../global-constants';
import { QueryService } from '../../comun/services/query.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-notificaciones-modal',
  templateUrl: './notificaciones-modal.component.html',
  styleUrl: './notificaciones-modal.component.css'
})
export class NotificacionesModalComponent {
  @Input() userid: number = 0;
  @ViewChild('scrollContainerNotificaciones') scrollContainer!: ElementRef<HTMLDivElement>;
  misdatos: any = {};
  notificaciones: any[] = [];
  loading: boolean = true;
  private shouldAutoScroll = true;
  private resizeObserver!: ResizeObserver;
  private lastScrollTop = 0;
  alreadyTriggered = false;
  alreadyTriggeredTop = false;
  alreadyTriggeredBottom = false;
  limit: number = 10;
  page: number = 1;
  filaHover: number = -1;

  constructor(private query: QueryService, private toastr: ToastrService) {}

  ngAfterViewInit() {
    const modal = document.getElementById('notificacionesModal');
    if (modal) {
      modal.addEventListener('shown.bs.modal', () => {
        this.getMisDatos();
      });
      const handler = () => {
        this.notificaciones.length = 0;
        this.notificaciones = [];
        this.page = 1;
        this.loading = true;
      };
      modal?.addEventListener('hidden.bs.modal', handler, { once: false });
    }
  }

  getMisDatos() {
    this.loading = true;
    this.query.query('misdatos', 'GET', { ID: 0 }).subscribe((resultado:any) => {
      this.misdatos = resultado;
      this.getNotificaciones();
    });
  }

  getNotificaciones() {
    this.query.query('buzon', 'GET', { limit: this.limit, page: this.page }).subscribe((resultado:any) => {
      this.notificaciones = resultado.registros;
      this.loading = false;
    });
  }

  filterNotificaciones() {
    return this.notificaciones.filter((notificacion: any) => {
      return notificacion.bu_borrado === '';
    });
  }

  leerMas(notificacion: any) {
    notificacion.leermas = !notificacion.leermas;
    this.query.query('buzon', 'LEER', { bu_id: notificacion.bu_id, leido: 'X' }).subscribe((resultado:any) => {
      notificacion.bu_leido = 'X';
      // Luego lo borras de firebase
      //this.chatService.borrarMensajeDespuesDeAvisar(notificacion.bu_id, 10, 'COMPARTIR_PERFIL');
    });
  }

  irPerfil(slug: string = '') {
    const url = GlobalConstants.urlServer + 'perfil/' + slug;
    window.open(url, '_blank', 'noopener,noreferrer');    
  }

  isNearBottom(): boolean {
    const el = this.scrollContainer.nativeElement;
    return el.scrollHeight - el.scrollTop - el.clientHeight < 40;
  }

  scrollToBottom(smooth = true): boolean {
    if (!this.shouldAutoScroll || !this.scrollContainer) {
      return false;
    }

    const el = this.scrollContainer.nativeElement;

    if (smooth) {
      el.scrollTo({
        top: el.scrollHeight,
        behavior: 'smooth'
      });
    } else {
      el.scrollTop = el.scrollHeight;
    }

    return true;
  }

  ngOnDestroy(): void {
    this.notificaciones = [];
    this.resizeObserver.disconnect();
  }  

  onScroll(event: Event) {

    const element = event.target as HTMLElement;
    const current = element.scrollTop;

    const scrollingUp = current < this.lastScrollTop;
    const scrollingDown = current > this.lastScrollTop;

    const atTop = current === 0;

    const atBottom =
      element.scrollHeight - element.scrollTop <= element.clientHeight + 5;

    // TOP
    if (scrollingUp && atTop && !this.alreadyTriggeredTop) {
      this.alreadyTriggeredTop = true;
      this.onReachTop();
    }

    // BOTTOM
    if (scrollingDown && atBottom && !this.alreadyTriggeredBottom) {
      this.alreadyTriggeredBottom = true;
      this.onReachBottom();
    }

    // Reset TOP
    if (current > 0) {
      this.alreadyTriggeredTop = false;
    }

    // Reset BOTTOM
    if (!atBottom) {
      this.alreadyTriggeredBottom = false;
    }

    this.lastScrollTop = current;
  }

  // TOP
  onReachTop() {
    this.cargarNotificacionesAnteriores();
  }

  // BOTTOM
  onReachBottom() {
    this.cargarNotificacionesSiguientes();
  }

  cargarNotificacionesAnteriores() {

  }

  cargarNotificacionesSiguientes() {
    if (this.notificaciones.length === 0)
      return;
    this.loading = true;
    this.query.query('buzon', 'GET', { limit: this.limit, page: this.page }).subscribe((resultado:any) => {
      // añadir abajo
      this.notificaciones = [
        ...this.notificaciones,
        ...resultado.registros
      ];
      this.page++;
      this.loading = false;
    });
  }

  borrarNotificacion(notificacion: any) {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres borrar esta notificación?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.query.query('buzon', 'BORRAR', { bu_id: notificacion.bu_id }).subscribe((resultado:any) => {
          notificacion.bu_borrado = 'X';
        });
      } else {
      }
    });
  }

  marcarLeido(notificacion: any) {
    this.query.query('buzon', 'LEER', { bu_id: notificacion.bu_id, leido: (notificacion.bu_leido == '' ? 'X' : '') }).subscribe((resultado:any) => {
      notificacion.bu_leido = (notificacion.bu_leido == '' ? 'X' : '');
      // Luego lo borras de firebase
      //this.chatService.borrarMensajeDespuesDeAvisar(notificacion.bu_id, 10, 'COMPARTIR_PERFIL');
    });
  }

}
